import { render, staticRenderFns } from "./ArticleTemplateIndex.vue?vue&type=template&id=78053f8e&scoped=true"
import script from "./ArticleTemplateIndex.vue?vue&type=script&lang=js"
export * from "./ArticleTemplateIndex.vue?vue&type=script&lang=js"
import style0 from "./ArticleTemplateIndex.vue?vue&type=style&index=0&id=78053f8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78053f8e",
  null
  
)

export default component.exports